import React, { useEffect, useState } from "react";
import MonthlyCommonDashboard from "../MonthlyCommonDashboard/MonthlyCommonDashboard";
import { GetLoanRegisterReport } from "../../../../Helpers/APIEndPoints/EndPoints";

const LoanRegister = () => {
  return (
    <>
      <MonthlyCommonDashboard
        PageName="LoanRegister"
        ExportToExcelUrl={GetLoanRegisterReport}
        UploadExcel={false} // true -> Option for UploadExcel, false -> NO Option for UploadExcel
        ExcelImport={""}
        openModal={""}
      />
    </>
  );
};

export default LoanRegister;
